// frontend_react/src/context/DataContext.jsx

import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import PropTypes from "prop-types";

import { useCompany } from "./CompanyContext";

const DataContext = createContext(null);

const initialFilters = {
  queryShop: "",
  queryDis: "",
  status: "",
};

export const DataProvider = ({ children }) => {
  const { companyUuid, companyName } = useCompany();

  const [filters, setFilters] = useState(initialFilters);

  const updateFilter = useCallback((key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  const updateFilters = useCallback((nextFilters = {}) => {
    setFilters((prev) => ({
      ...prev,
      ...nextFilters,
    }));
  }, []);

  const resetFilters = useCallback(() => {
    setFilters(initialFilters);
  }, []);

  useEffect(() => {
    resetFilters();
  }, [companyUuid, resetFilters]);

  const value = useMemo(
    () => ({
      filters,

      companyUuid,
      companyName,

      updateFilter,
      updateFilters,
      resetFilters,
    }),
    [
      filters,
      companyUuid,
      companyName,
      updateFilter,
      updateFilters,
      resetFilters,
    ]
  );

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
};

DataProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useData = () => {
  const context = useContext(DataContext);

  if (!context) {
    throw new Error("useData must be used within DataProvider");
  }

  return context;
};